import { Component } from "@angular/core";

@Component({
    selector: 'default-component',
    template: ''
})
export class DefaultComponent {
    // Dummy component. Before landing here, there will be a redirection to the first listed page.
}